import { CHECK_BOX_VALUE } from '../../constants';
import dayjs from 'dayjs';

export const initialState = {
  status: 'idle',
  loading: false,
  errors: {}, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  apiSuccessResponse: {
    activate: false,
    deactivate: false,
    create: false,
    update: false,
  }, // You can store the api success response here
  isActivate: false,
  gridRowSelectedData: [], // You can store the grid row selected data here
  gridRowSelectedCount: 0,
  searchTerm: '',
  selectedSearchTerm: null,
  serviceLevelTotalRecords: 0,
  searchData: [], // You can store the service level data here
  searchContainesData: [], // You can store the service level data here
  isActiveCheckbox: CHECK_BOX_VALUE.yes, // You can store the active checkbox value here
  isPremiumCheckbox: CHECK_BOX_VALUE.no, // You can store the premium checkbox value here
  filteredData: [], // You can store the filtered data here
  serviceResponseTypeObj: null, // You can store the service response type here,
  serviceLevelForm: {
    name: '',
    description: '',
    id: 0,
    active_Flag: true,
    premium_Flag: false,
    available_On_Contract_Flag: true,
    service_Level_Type_Id: '',
    service_Response_Type_Id: '',
    service_Location_Id: '',
    work_Order_Type_Id: '',
    ship_Method_Id: '',
    has_Addon_Service_Flag: '',
    service_Offering_Addon_Id: '',
    days_Supported: '',
    hours_Supported: '',
    ordered_By_Time: dayjs(new Date().setHours(new Date().getHours(), 0)),
    on_Site_Compliance_Time: dayjs(new Date().setHours(new Date().getHours(), 0)),
    exclude_Holidays: false,
    exclude_Weekends: false,
  }, // You can store Srvice Level Form Data here
  isNeedToCallSearchAPI: true,
  isSearchedDataFetching: false,
  slArray:[{}],
  isResetSl:false,
  currentPage:1,
};
